import immer from '@reduck/plugin-immer';

// test

export default immer;
//# sourceMappingURL=immer.esm.js.map
